import {Recurrence} from "../../models/Recurrence";
import {WrapperFactory} from "../WrapperFactory";
import {Task} from "../../models/Task";
import {CustomProduct} from "../../models/CustomProduct";

let recurrencesApi = {
    async get(filters, page=1, token, companyId, fields=null, relationships= ['category:id,name', 'filters.subfilters', 'automationList']){
        let response = await window.axios.get('/api/recurrences', {
            params:{
                api_token:token,
                company_logged:companyId,
                page: page,
                fields: fields,
                relationships: relationships,
                ...filters
            }
        });

        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new Recurrence(e));
        return wrapper
    },
    async find(id, token, companyId, fields= null, relationships= ['category:id,name', 'filters.subfilters', 'customProducts:id,name,reference']){
        let response = await window.axios.get('/api/recurrences/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
                fields: fields,
                relationships: relationships,
            }
        });
        return new Recurrence(response.data);
    },
    async create(recurrence, token, companyId){
        let response = await window.axios.post('/api/recurrences', recurrence, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Recurrence(response.data);
    },
    async edit(recurrence, token, companyId){
        let response = await window.axios.put('/api/recurrences/'+recurrence.id, recurrence, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Recurrence(response.data);
    },
    async delete(recurrence, token, companyId){
        let response = await window.axios.delete('/api/recurrences/'+recurrence.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
    async addProduct(recurrence, productId, token, companyId){
        let response = await window.axios.post(`/api/recurrences/+${recurrence.id}+/add-product`, {
            custom_product_id: productId
        },{
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.map(c=>new CustomProduct(c));
    },
    async removeProduct(recurrence, productId, token, companyId){
        let response = await window.axios.post(`/api/recurrences/+${recurrence.id}+/remove-product`, {
            custom_product_id: productId
        }, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.map(c=>new CustomProduct(c));
    },
}

export default recurrencesApi